export default __webpack_public_path__ + "static/media/PIANIFICAZIONE_MENTALE_ICONA1.156bfb10.svg";